import _MagnifyingGlassIcon from "@adsk/alloy-react-icon/es/lib/MagnifyingGlassIcon";
import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
const _excluded = ["style", "className", "showIcon", "placeholder", "isOpen"];
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { useTranslation } from '../../i18n';
const SearchInput = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      showIcon = true,
      placeholder: placeholderProp,
      isOpen
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation();
  const defaultPlaceholder = isOpen ? t('SEARCH') : t('SELECT');
  const placeholder = placeholderProp !== null && placeholderProp !== void 0 ? placeholderProp : defaultPlaceholder;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    $_css: [{
      display: 'flex',
      flex: 'auto',
      alignItems: 'center',
      overflow: 'hidden'
    }, style]
  }, showIcon && /*#__PURE__*/React.createElement(_MagnifyingGlassIcon, {
    size: 20,
    style: [{
      minWidth: 20,
      marginLeft: "-".concat(theme.spacing.XXXS, "px"),
      marginRight: theme.spacing.XXXS,
      color: theme.tokens.colors.icon.tertiary.value
    }]
  }), /*#__PURE__*/React.createElement(_StyledInput, _extends({
    ref: ref,
    "data-testid": 'Dropdown__input',
    placeholder: placeholder
  }, props, {
    $_css2: [_objectSpread(_objectSpread({
      flexGrow: 1,
      overflow: 'hidden',
      border: 'none',
      outline: 'none',
      color: 'inherit',
      '&::placeholder': {
        color: props.disabled ? theme.tokens.colors.text.inactive.value : theme.tokens.colors.text.tertiary.value
      },
      backgroundColor: 'transparent'
    }, !isOpen && {
      cursor: 'pointer'
    }), props.disabled && {
      cursor: 'not-allowed'
    }), theme.typography.labelMedium]
  })));
});
SearchInput.displayName = 'SearchInput';
SearchInput.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Input placeholder text */
  placeholder: PropTypes.string,
  /** Whether to show the search icon */
  showIcon: PropTypes.bool,
  /** Whether Dropdown menu is open */
  isOpen: PropTypes.bool.isRequired
};
export default SearchInput;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledInput = _styled2("input").withConfig({
  displayName: "SearchInput___StyledInput",
  componentId: "sc-6e101x-0"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=SearchInput.js.map